import type { FC } from 'react';

import * as css from './placeholder-warning.css';

export type PlaceholderWarningReasonKey =
  | 'bodyMissing'
  | 'imageCardCoverMissing'
  | 'kanbanStatusMissing'
  | 'relatedCurrentRowMissing'
  | 'tagsEmpty'
  | 'tagsNoRow'
  | 'titleMissing';

export interface PlaceholderWarningProps {
  reason?: string;
  reasonKey?: PlaceholderWarningReasonKey;
  role?: string;
}

const REASON_LABELS: Record<PlaceholderWarningReasonKey, string> = {
  bodyMissing: 'Body binding is missing.',
  imageCardCoverMissing: 'Image-card cover binding is missing.',
  kanbanStatusMissing: 'Kanban status binding is missing.',
  relatedCurrentRowMissing: 'Related current-row binding is missing.',
  tagsEmpty: 'No tags are available for this row.',
  tagsNoRow: 'Tag row binding is missing.',
  titleMissing: 'Title binding is missing.',
};

export const PlaceholderWarning: FC<PlaceholderWarningProps> = ({
  reason,
  reasonKey,
  role,
}) => {
  const resolvedReason = reasonKey ? REASON_LABELS[reasonKey] : (reason ?? '');

  return (
    <div
      className={css.warning}
      role="alert"
      data-sl-state="missing-binding"
      data-sl-role="placeholder-warning"
      data-sl-binding-role={role}
    >
      <strong className={css.label}>Missing binding</strong> {resolvedReason}
    </div>
  );
};
